import React from 'react'
let vector = ['1'];
let validate_count = 1;
import ReCAPTCHA from "react-google-recaptcha";

const Form = function form ({info,text,form,onChange,onSubmit,recaptchaRefContact}){
    return (
    <div>
        <div className="back flex w90">
            <a href={https} className="flex">
                <img src={https+"img/back.svg"} alt="⬅"/>
                <span>Atrás</span>
            </a>
        </div>

        <section className="contact">
            <div className="container colflex">
                <div className="mapContact colflex">
                <div className="map" id="gmap">

                </div>
                <div className="address2 dnone">
                    <div href="" className="flex">
                    <img src={https+"img/cellphone.svg"} alt="📱"/>
                    <p>{info.cellphone}</p>
                    </div>
                    <div href="" className="flex">
                    <img src={https+"img/marker.svg"} alt="🗺"/>
                    <p>{info.address} <br/>{info.city} </p>
                    </div>
                    <div href="" className="flex">
                    <img src={https+"img/envelope.svg"} alt="📩"/>
                    <p>{info.mail}</p>
                    </div>
                </div>
                </div>
                <div className="infoContact colflex">
                <h2>{text.title}</h2>
                <p>
                    {text.text}
                </p>
                <form id="formContact" action="" onSubmit={onSubmit}>
                    <ReCAPTCHA
                        ref={recaptchaRefContact}
                        size="invisible"
                        sitekey="6LfcjZ0fAAAAAEqsOPo6f6Cmw9e2din9S2TxcM7m"
                    />
                    <input
                        type="text"
                        name="name"
                        placeholder="Nombre..."
                        value={form.name}
                        onChange={onChange}
                    />
                    <input
                        type="text"
                        name="phone"
                        placeholder="Teléfono..."
                        value={form.phone}
                        onChange={onChange}
                    />
                    <input
                        type="text"
                        name="mail"
                        placeholder="Email..."
                        value={form.mail}
                        onChange={onChange}
                    />
                    <textarea 
                        rows="6" 
                        name="message"
                        placeholder="Mensaje..."
                        value={form.message}
                        onChange={onChange}
                    ></textarea>
                    <div className="policy">
                    <p>*Al enviar este mensaje autoriza el <a target="_blank" href={https+'terms'}>uso y tratamiento de datos.</a></p>
                    <button type="submit">
                        <a className="btnFormContacto">Enviar</a>
                    </button>
                    </div>
                </form>
                </div>
            </div>
            <div className="addressContact colflex">
                <div className="flex">
                <img src={https+"img/cellphone.svg"} alt="📱"/>
                <p>{info.cellphone}</p>
                </div>
                <div className="flex">
                <img src={https+"img/marker.svg"} alt="🗺"/>
                <p>{info.address} <br/>{info.city} </p>
                </div>
                <div  className="flex">
                <img src={https+"img/envelope.svg"} alt="📩"/>
                <p>{info.mail}</p>
                </div>
            </div>
        </section>
    </div>   
)
}

export default Form